// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;Let everything that has breath&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;praise the Lord.<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Alleluia.<br> </p> </div></div>";
// Exports
module.exports = code;